<template>
    <v-container container--fluid grid-list-lg class="pa-0 pb-6">
        <v-layout v-if="!showData" row wrap class="pa-2 mx-auto full-height">
            <v-flex xs12 class="justify-center text-center mt-12">
                <span class="font-weight-bold title">Loading Data... <i class="fas fa-circle-notch fa-spin"></i></span>
            </v-flex>
        </v-layout>
        <v-layout v-if="showData" row wrap class="pa-2 mx-auto full-height">
            <v-flex xs12 class="justify-space-between text-left mt-2">
                <h1 ref="dashboard" class="grey--text lighten-3 mb-2">Dashboard</h1><v-select v-if="hasTeam" return-object class="ml-4 col-sm-3" dense outlined :items="sportsFiltered" label="Sport Profile" v-model="sport"></v-select>
            </v-flex>
            <v-flex xs4 md4 class="text-center">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover1'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover1' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'profile', query: { sport: this.sport.text.toLowerCase().trim().replace('register for ','') }  }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-address-card icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Profile</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Update your contact details</h2>
                        <p v-cloak v-if="needRequiredFields" class="red--text mt-2 mb-0 pb-0">
                            <v-alert v-cloak :value="true" outlined transition="scale-transition" type="error" class="pa-2 caption"
                                >Missing information, please update your profile</v-alert
                            >
                        </p>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="user.is_eft">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover15'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover15' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'eft' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-piggy-bank icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">EFT Details</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Update your EFT details</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="hasTeam">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover2'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover2' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'membership', query: { sport: this.sport.text.toLowerCase().trim().replace('register for ','') } }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-basketball-ball icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Registration</h1>
                        <h2 v-if="!user.non_pl" class="text-center font-weight-regular subtitle-1">{{sport.text.toLowerCase().trim().replace('register for ','') | capitalize}} registration <span v-if="msPivotField(sport.value)">expiry date: {{ msPivotField(sport.value) }}</span></h2>
                        <h2 v-else class="text-center font-weight-regular subtitle-1">This profile does not require registration.<br />Please contact us for further details.</h2>
                        <p v-cloak v-if="!user.non_pl && msPivotField(sport.value, 'memb_renewal') && !needRequiredFields" class="col-12 mt-2 mb-0 pb-0 px-0">
                            <v-btn medium dark color="secondary" :to="{ name: 'membership', query: { sport: this.sport.text.toLowerCase().trim().replace('register for ','') } }"><v-icon class="reg-btn" medium left>how_to_reg</v-icon> <span class="d-none d-sm-flex">REGISTER NOW</span></v-btn>
                        </p>
                        <p v-cloak v-if="needRequiredFields" class="red--text mt-2 mb-0 pb-0">
                            <v-alert v-cloak :value="true" outlined transition="scale-transition" type="error" class="pa-2 caption"
                                >Missing information, please update your profile</v-alert
                            >
                        </p>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover3'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover3' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'invoicesList' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-calculator icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Invoices</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Pay your game fees or any other invoices</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="hasTeam">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover4'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover4' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'teamsList' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-users icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Teams</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Team History, Attendance & Finances</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="hasTeam && enabledStats">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover12'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover12' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'statsList' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-chart-bar icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Stats</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Stats History</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="isManager">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover13'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover13' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'noticeboard' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-clipboard-list icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Noticeboard</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Noticeboard Players</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover5'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover5' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'ordersList' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-file-invoice-dollar icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Receipts</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">History of accounts</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover6'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover6' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'products' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-shopping-cart icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Store</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Player programs, courses and events</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="isAdult">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover7'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover7' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'teamNomination' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-users-cog icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Team Nomination</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Enter your team into the next competition</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="user.is_ref">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover8'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover8' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'referee' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-user-ninja icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Competition Roster</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">See your own local competition roster</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="user.is_ref">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover11'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover11' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'refereeavail' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-calendar-check icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Competition Availability</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Set your competition availability</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs4 md4 class="text-center" v-if="user.is_roster">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover9'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover9' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'roster' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-calendar-alt icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Event Roster</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">See your own event roster</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
            <!-- <v-flex xs4 md4 class="text-center">
                <v-card
                    ripple
                    text
                    hover
                    @mouseover.native="hover = 'hover10'"
                    @mouseleave.native="hover = ''"
                    :color="`${hover == 'hover10' ? 'primary theme--dark' : 'grey lighten-3'}`"
                    class="py-3"
                    :to="{ name: 'bookings' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-business-time icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">Court Hire</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">Book your favorite sport</h2>
                    </v-card-title>
                </v-card>
            </v-flex> -->
            <v-flex xs4 md4 class="text-center" v-if="user.is_hpc">
                <v-card
                    ripple
                    text
                    hover
                    :color="'primary theme--dark'"
                    class="py-3"
                    :to="{ name: 'hpcDashboard' }"
                >
                    <v-card-title class="justify-center">
                        <i class="fas fa-dumbbell icx-card pb-3"></i>
                        <h1 class="text-uppercase title-card ma-0">HPC</h1>
                        <h2 class="text-center font-weight-regular subtitle-1">High Performance Centre</h2>
                    </v-card-title>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            hover: "",
            sport: {text: 'Select Sport Profile', value: 0},
            sports: [],
            all_sports: [],
            enabledStats: window.LMP.statsEnabled,
        };
    },
    computed: {
        showData() {
            return this.$store.getters["user/userStatus"] == "success";
        },
        user() {
            let sports = this.$store.getters["user/getSports"];
            if(_.size(sports)){
                this.sports = sports;
            }

            let all_sports = this.$store.getters["user/allSports"];
            if(_.size(all_sports)){
                this.all_sports = all_sports;

                if(!_.size(sports)){
                    this.sports = all_sports;
                }
            }

            return this.$store.getters["user/getProfile"];
        },
        sportsFiltered(){
            let s = _.differenceBy(this.all_sports, this.sports, 'value');

            _.forEach(this.sports, function(obj) {
                s.push(obj);
            });

            return _.sortBy(s, 'value');
        },
        isAdult() {
            return moment(this.user["dob"], "DD-MM-YYYY").isBefore(moment().subtract(18, "years"));
        },
        hasTeam() {
            // return true;
            return this.user["nb_teams"] > 0;
        },
        isManager() {
            // return true;
            return this.user["is_man"];
        },
        needRequiredFields() {
            if (
                !(
                    this.user.firstname &&
                    this.user.lastname &&
                    this.user.dob &&
                    this.user.gender &&
                    this.user.address &&
                    this.user.suburb &&
                    this.user.state &&
                    this.user.postcode &&
                    this.user.mobile &&
                    this.user.email &&
                    this.user.ec_fullname &&
                    this.user.ec_mobile &&
                    this.user.agreed_to_terms &&
                    this.user.agreed_to_privacy
                )
            ) {
                return true;
            }

            return false;
        },
        regoLink() {
            // if(!(this.user.firstname && this.user.lastname && this.user.dob && this.user.gender && this.user.address && this.user.suburb && this.user.state && this.user.postcode && this.user.mobile && this.user.email && this.user.ec_fullname && this.user.ec_mobile && this.user.agreed_to_terms && this.user.agreed_to_privacy)){
            //     return '';
            // }

            return "membership";
        },
        membershipStatus() {
            if (!this.user.memb_renewal && this.user.expiry_date) {
                return "REGISTERED";
            } else if (this.user.memb_renewal && this.user.expiry_date) {
                return "PLEASE RENEW";
            }

            return "UNREGISTERED";
        },
    },
    watch: {
        sports(n, o) {
            if(n){
                this.sport = this.sportsFiltered[0];
                if(this.user.main_sport){
                    this.sport = _.find(this.sportsFiltered, ['value', this.user.main_sport]);
                }
                this.msPivotField(n[0].value);
            }
        },
    },
    methods: {
        selSport(){
            //code goes here
        },
        msPivotField(sport_id, field = 'expiry_date') {
            let sportObj = _.filter(this.sportsFiltered, ['value', sport_id]);
            if(sportObj.length < 1){
                return false;
            }

            return sportObj[0][field];
        },
    },
    beforeCreate() {

    },
    mounted() {
        // let top = this.$refs['dashboard'].offsetTop;
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 500);
    }
};
</script>

<style lang="scss" scoped>
[v-cloak], .v-cloak {
    display: none;
}
[v-cloak] > *, .v-cloak > * {
    display: none;
}

.full-height .flex {
    display: flex;
}

.full-height .flex > .v-card {
    flex: 1 1 auto;
}

.title-card {
    font-size: 24px !important;
}

::v-deep .v-select__selection.v-select__selection--comma {
    text-transform: capitalize;
}

::v-deep .v-list-item__title {
    text-transform: capitalize;
}

.v-card {
    .icx-card {
        color: #bdbdbd;
        font-size: 42px;
        flex-basis: 100%;
        text-align: center;
    }

    .hh-logo {
        fill: #bdbdbd;
        width: 52px;
    }

    &:hover {
        .icx-card {
            color: #ffffff;
        }

        .hh-logo {
            fill: #ffffff;
        }

        h2.subtitle-1 {
            color: #ffffff;
        }

        h2.subtitle-2 {
            color: #ffffff;
        }
    }
}

.title-card {
    flex-basis: 100%;
    text-align: center;
}

.v-card--hover.primary h1.title-card {
    // font-family: 'Oswald',sans-serif !important;
    color: #fff !important;
}

@media only screen and (max-width: 767px) {
    .v-card {
        // max-width: 33.33% !important;
        padding: 8px 0 !important;
    }
    .v-card__title {
        padding: 8px !important;
    }
    .v-card__title i.icx-card {
        padding-bottom: 8px !important;
        font-size: 36px !important;
    }
    .v-card__title h1.title-card {
        font-size: 12px !important;
        line-height: 14px !important;
        word-break: break-word;
    }
    .v-card__title h2.subtitle-1 {
        display: none;
    }
    ::v-deep .v-card__title .v-alert {
        margin-top: 8px !important;
        margin-bottom: 0 !important;
    }
    ::v-deep .v-card__title .v-alert .v-alert__wrapper {
        flex-direction: column !important;
    }
    ::v-deep .v-card__title .v-alert .v-alert__wrapper .v-alert__icon.v-icon {
        align-self: center !important;
        margin: 0 !important;
    }
    ::v-deep .v-card__title .v-alert .v-alert__wrapper .v-alert__content {
        font-size: 10px !important;
        letter-spacing: 0px !important;
        line-height: 16px !important;
        word-break: break-word !important;
    }
    i.v-icon.reg-btn {
        margin: 0 !important;
        font-size: 26px !important;
    }
}
</style>
